var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 25.864,
    viewBox: "0 0 27 25.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-shopping-cart",
    "data-name": "Icon feather-shopping-cart",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M14.273,31.136A1.136,1.136,0,1,1,13.136,30,1.136,1.136,0,0,1,14.273,31.136Z",
    transform: "translate(-2.545 -6.909)",
    fill: "none",
    stroke: "#3dc5d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M30.773,31.136A1.136,1.136,0,1,1,29.636,30,1.136,1.136,0,0,1,30.773,31.136Z",
    transform: "translate(-6.545 -6.909)",
    fill: "none",
    stroke: "#3dc5d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1.5,1.5H6.045L9.091,16.716a2.273,2.273,0,0,0,2.273,1.83H22.409a2.273,2.273,0,0,0,2.273-1.83L26.5,7.182H7.182",
    fill: "none",
    stroke: "#3dc5d6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping_cart.45ea201c9465ce6ad26a59e21d20c797.svg";
export { ForwardRef as ReactComponent };